import { Component, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import * as d3 from 'd3';
import { IomService } from 'src/app/services/iom.service';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
	selector: 'app-pareto',
	templateUrl: './Pareto.html',
	styleUrls: ['./Pareto.css']
})

export class ParetoComponent {
	totalpercentage: number;
	constructor(public iomservice: IomService, private spinner: NgxSpinnerService) { }
	@Input()
	GraphData: any;
	// ngOnChanges() {
	// 	if (this.GraphData != null)
	// 		this.RenderPareto();
	// }
	ngAfterViewInit() {
		if (this.GraphData != null)
			this.RenderPareto(this.GraphData);
	}
	RenderPareto(inputData) {
		var data = inputData.chartData;
		var paretoid = document.getElementById("keymsg_10005");
		if (data[0].HeaderTwo != null)
			paretoid.innerHTML = data[0].HeaderOne + '<br>' + data[0].HeaderTwo;
		else
			paretoid.innerHTML = data[0].HeaderOne;

		data.sort(function (a, b) {
			return a.Data - b.Data;
		});
		for (var i = 0; i < data.length; i++) {
			data[i].oldValue = data[i].Value;
			if(data[i].Value.length>20){
			data[i].Value = data[i].Value.substring(0,20)+"...";
			}
			else{
				data[i].Value = data[i].Value;
			}
		}
		// format the data
		var Total = data[0].TotalTicketCount;//data.map(Vall => Vall.Data).reduce((acc, Vall) => Vall + acc);
		data.forEach(function (d) {
			d.Data = +d.Data;
			d.Parato = parseFloat((d.Data / Total * 100).toFixed(2));
		});

		this.totalpercentage = data.map(Vall => Vall.Parato).reduce((acc, Vall) => Vall + acc);
		let that = this;
		data.forEach(function (d) {
			d.Data = +d.Data;
			d.Parato = +parseFloat(that.totalpercentage.toFixed(2));
			that.totalpercentage = that.totalpercentage - parseFloat((d.Data / Total * 100).toFixed(2));
		});


		var containerID = inputData.chartContainerName;
		var w = document.getElementById(containerID).getBoundingClientRect().width,
			h = 400
		var margin = {
			top: 5,
			right: 80,
			bottom: 10,
			left: 120
		},
			margin2 = {
				top: h - 40,
				right: 50,
				bottom: 10,
				left: 120
			}
		var width = w - margin.left - margin.right,
			height = h - margin.top - margin.bottom,
			height2 = h - margin2.top - margin2.bottom;


		document.getElementById(containerID).innerHTML = ""



		//axix_addition = 10
		//data_cnt = 5


		// set the dimensions and margins of the graph
		//var margin = {top: 20, right: 20, bottom: 30, left: 100},
		//width = 500 - margin.left - margin.right,
		//height = 500 - margin.top - margin.bottom;

		// set the ranges
		var y = d3.scaleBand()
			.range([height, 0])
			.padding(0.1);

		var y1 = d3.scaleBand()
			.range([height, 0])
			.padding(0.1);

		var x = d3.scaleLinear()
			.range([0, width]);

		var x1 = d3.scaleLinear()
			.range([0, width]);

		var color = d3.scaleLinear()
			.range(["lightblue", "#008FFF"]);

		// append the svg object to the body of the page
		// append a 'group' element to 'svg'
		// moves the 'group' element to the top left margin
		var svg = d3.select("#" + containerID).append("svg")
			.attr("width", width + margin.left + margin.right)
			.attr("height", height + margin.top + margin.bottom)
			.append("g")
			.attr("transform",
				"translate(" + margin.left + "," + margin.top + ")");

		var line = d3.line()
			.x(function (d, i) { return x1(d.Parato); })
			.y(function (d) { return y1(d.Value) + y1.bandwidth() / 2; })
			.curve(d3.curveMonotoneX)


		// Scale the range of the data in the domains
		x.domain([0, d3.max(data, function (d) { return d.Data; }) + 10])
		color.domain([d3.min(data, function (d) { return d.Data; }), d3.max(data, function (d) { return d.Data; })])
		y.domain(data.map(function (d) { return d.Value; }));

		x1.domain([0, 110])
		y1.domain(data.map(function (d) {
			return d.Value;
		}));

		const tooltip = d3.select('body')
			.append("div")
			.attr('class', 'tooltip')
			.style("opacity", 0);
		// append the rectangles for the bar chart
		svg.selectAll(".bar")
			.data(data)
			.enter().append("rect")
			.attr("class", "bar")
			.attr("fill", function (d) { return color(d.Data) })
			.attr("width", function (d) { return x(d.Data); })
			//.attr("y", function (d) { return y(d.Value); })
			.attr("y", function (d) { return y(d.Value) + y.bandwidth() / 2 - 8; })
			//.attr("height", y.bandwidth())
			.attr("height", 25)
			.on('mouseenter', function (d, i) {
				d3.select(this).style("stroke", '#ffffff');
				//show tooltip
				tooltip.transition().duration(50).style('opacity', 0.9);
				tooltip.html('<div>' + d.oldValue + ' : ' + d.Data + ' (' + d.Parato + '%)</div>')
					.style('left', (d3.event.pageX - 55) + 'px')
					.style('top', (d3.event.pageY) + 'px')
					.style("display", "block")
					.style('border-color', d3.select(this).style('fill'));
			})
			.on("mouseleave", function (actual, i) {
				//hide tooltip
				tooltip.transition().duration(800).style('opacity', 0);
			});

		svg.selectAll(".label")
			.data(data)
			.enter().append('text')
			.attr("class", "label")
			.attr("font-size", "11")
			.attr("x", function (d) {
				return x(d.Data) + 5;
			})
			// .attr("y", function (d, i) {
			// 	return y(d.Value) + 20
			// })
			.attr("y", function (d, i) {
				return y(d.Value) + y.bandwidth() / 2 + 12
			})
			.text(function (d, i) {
				return d.Data;
			})

		svg.append("path")
			.datum(data)
			.attr("class", "line")
			.attr("d", line)
			.attr('fill', 'none')
			.attr('stroke', '#069')
			.attr('stroke-width', '3')
			.attr('stroke-dasharray', '5');

		svg.selectAll(".dot")
			.data(data)
			.enter().append("circle")
			.attr("class", "dot")
			.attr("cx", function (d, i) { return x1(d.Parato) })
			.attr("cy", function (d) { return y1(d.Value) + y1.bandwidth() / 2 })
			.attr("r", 4)
			.attr('fill', 'green')
			.attr('stroke', '#fff')
			.attr('stroke-width', '2')

		svg.selectAll(".labelline")
			.data(data)
			.enter().append('text')
			.attr("class", "labelline")
			.attr("font-size", "11")
			.attr("x", function (d) {
				return x1(d.Parato) + 10;
			})
			// .attr("y", function (d, i) {
			// 	return y1(d.Value) + 10
			// })
			.attr("y", function (d, i) {
				return y1(d.Value) + y1.bandwidth() / 2
			})
			.text(function (d, i) {
				return d.Parato + "%";
			})

		/*
		// add the x Axis
		svg.append("g")
		.attr("transform", "translate(0,0)")
		.call(d3.axisTop(x))
		.select(".domain").remove()
		
		
		// parato axis
		svg.append("g")
		.attr("transform", "translate(0,"+height+")")
		.call(d3.axisBottom(x1))
		.select(".domain").remove()
		*/
		// add the y Axis
		svg.append("g")
		.style("font-size", "6")
			.call(d3.axisLeft(y))			
			.select(".domain").remove();			
	}
}
